import { render, staticRenderFns } from "./EstimatedBilling.vue?vue&type=template&id=2e6b60e2&scoped=true&"
import script from "./EstimatedBilling.vue?vue&type=script&lang=js&"
export * from "./EstimatedBilling.vue?vue&type=script&lang=js&"
import style0 from "./EstimatedBilling.vue?vue&type=style&index=0&id=2e6b60e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b60e2",
  null
  
)

export default component.exports